import { createStore } from 'effector'

import { IToastItem } from './types'

export default createStore<IToastItem[]>([])
